import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enroll-user',
  templateUrl: './enroll-user.component.html',
  styleUrls: ['./enroll-user.component.scss']
})
export class EnrollUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
